<template>
   <div class="text-input">
      <label v-if="label"><b>{{label}}</b></label>
      <div class="form-group">

        <select class="form-control" v-model="displaySelected" @change="updateValue()" :aria-label="label || placeholder" :disabled="disabled">
          <option v-if="placeholder && !label" value="" disabled selected>{{placeholder}}</option>
          <option v-for="item in items" :key="item.value" :value="item.value">{{item.text}}</option>
        </select>
        <i class="fa fa-chevron-down"></i>
      </div>
   </div>
</template>

<script>
export default {
  name: "BasicDropdown",
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {},
    //items: [{text: 'text visible on options', value: value stored for use}]
    items: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return{
      displaySelected: null
    }
    
  },
  methods:{
    updateValue(){
      this.$emit("change", this.displaySelected);
      this.$emit("input", this.displaySelected);
    }
  },
  created(){
    // If we have a placeholder and no label, start with empty value to show placeholder
    if (this.placeholder && !this.label && !this.value) {
      this.displaySelected = '';
    } else {
      this.displaySelected = this.value;
    }
  },
  watch: {
    value(newValue) {
      this.displaySelected = newValue;
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-group{
    margin-bottom: 0px;
    select {
      -webkit-appearance: none;
      -moz-appearance: none;
      -o-appearance: none;
      /* no standardized syntax available, no ie-friendly solution available */
    }
    select + i.fa {
      float: right;
      margin-top: -26px;
      margin-right: 5px;
      /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
      pointer-events: none;
      /* everything after this is just to cover up the original arrow */
      /* (for browsers that don't support the syntax used above) */
      background: inherit;
      padding-right: 5px;
    }
  }
</style>
